import React from 'react';
import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

const WordToSort = React.forwardRef(({ name, backgroundColor, transformStyle, color }, ref) => {
    return (
        <div className='word-to-sort' ref={ref}
             style={{
                 transform: transformStyle,
                 transition: 'transform 0.5s ease',
                 backgroundColor: backgroundColor,
                 fontWeight: '500',
                 color: color}}>
            {name}
        </div>
    );
});

export default WordToSort;
